import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { useIsDesktop } from "../../../hooks/useIsDesktop";
import { useUser } from "../../../hooks/useUser";
import Icon from "../Icon/Icon";
import styles from "./style.module.css";

const BottomBar = () => {
  const { pathname } = useLocation();
  const splitPath = pathname.split("/");
  const activeMenu = splitPath[splitPath.length - 1] || "";
  const { isLoggedIn } = useUser();
  const isDesktop = useIsDesktop();
  const { t } = useTranslation("bottomBar");

  const menuItems = useMemo(() => {
    const items = [
      {
        name: t("homePage"),
        path: "/",
        icon: isDesktop
          ? "home-pink"
          : activeMenu === ""
          ? "home-white"
          : "home",
        active: activeMenu === "",
        hideOnDesktop: true,
      },

      isLoggedIn && {
        name: t("myLoan"),
        path: "/my-loans",
        icon: isDesktop
          ? "coin-pink"
          : activeMenu === "my-loans"
          ? "coin-white"
          : "coin",
        active: activeMenu === "my-loans",
      },

      isLoggedIn && {
        name: t("profile"),
        path: "/profile",
        icon: isDesktop
          ? "profile-pink"
          : activeMenu === "profile"
          ? "profile-white"
          : "profile",
        active: activeMenu === "profile",
        // hideOnMobile: true,
      },

      (!isDesktop || isLoggedIn) && {
        name: t("contactUs"),
        path: "/contact-us",
        icon: isDesktop
          ? "support-pink"
          : activeMenu === "contact-us"
          ? "support-white"
          : "support",
        active: activeMenu === "contact-us",
      },
    ];

    return isDesktop
      ? items.filter(Boolean).filter((item) => !item.hideOnDesktop)
      : items.filter(Boolean).filter((item) => !item.hideOnMobile);
  }, [activeMenu, isDesktop, isLoggedIn, t]);

  if (isDesktop) {
    return (
      <>
        {menuItems.map((item) => (
          <MenuItem key={item.path} {...item} />
        ))}
      </>
    );
  }

  return (
    <footer className={styles.container}>
      {menuItems.map((item) => (
        <MenuItem key={item.path} {...item} />
      ))}
    </footer>
  );
};

const MenuItem = ({ name, path, icon, active }) => {
  const isDesktop = useIsDesktop();
  return (
    <Link
      className={`${styles.menu} ${
        active && isDesktop ? styles.activeDesktop : ""
      }`}
      to={path}
    >
      <Icon className={active ? styles.activeIcon : ""} name={icon} />
      <p data-active={active}>{name}</p>
    </Link>
  );
};

export default BottomBar;
